// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesGrid_container__awiiH","item":"CategoriesGrid_item__vsloc","itemLabel":"CategoriesGrid_itemLabel__WyM2j"};